import { History } from "history";
import { toastError } from "@helpers/utils";
import { AppAsyncThunk } from "@/redux/hooks";
import { purchasesApi } from "./purchasesApi";

export const handlePurchaseOrderCopy = (
    purchaseOrderId: number,
    history: History
): AppAsyncThunk<boolean> => async (dispatch) => {
    if (!purchaseOrderId) {
        console.error("No purchase order id provided");
        return false;
    }

    try {
        const purchaseOrder = await dispatch(
            purchasesApi.endpoints.getPurchaseOrder.initiate(purchaseOrderId, {
                subscribe: false,
            })
        ).unwrap();

        history.push("/dashboard/purchasing/new", {
            copyPurchaseOrder: purchaseOrder,
        });

        return true;
    } catch (e) {
        toastError(e);
        return false;
    }
};
